import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { MobileNav, Navbar } from 'components/navigation';
import { useUser } from 'libs';
import { SpotlightLogoIcon } from 'icons';

const Topbar = () => {
  const { brokerage, features } = useUser();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [pageTitle, setPageTitle] = useState<string | null>(null);

  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/rates')) setPageTitle('Rates');
    if (pathname.startsWith('/scenarios')) setPageTitle('Scenarios');
    if (pathname.startsWith('/lenders')) setPageTitle('Lenders');
    if (pathname.startsWith('/guidelines')) setPageTitle('Policies');
    if (pathname.startsWith('/alternative-lending')) setPageTitle('Alternative Lending');
    if (pathname === '/ai') setPageTitle('AI Assistant');
    if (pathname.startsWith('/ai/conversations')) setPageTitle('Spotlight Spark');
    if (pathname === '/settings') setPageTitle('Your account');
    if (pathname.startsWith('/settings/payment-method')) setPageTitle('Payment method');
    if (pathname.startsWith('/settings/subscriptions')) setPageTitle('Subscriptions');
    if (pathname.startsWith('/settings/team-status')) setPageTitle('Team status');
    if (pathname.startsWith('/settings/upgrade')) setPageTitle('Upgrade');
    if (pathname === '/team-management') setPageTitle(`Manage ${brokerage?.name}`);
    if (pathname.startsWith('/team-management/members')) setPageTitle('Members');
    if (pathname.startsWith('/team-management/documents')) setPageTitle('Documents');
    if (pathname.startsWith('/team-management/announcements')) setPageTitle('Announcements');
    if (pathname.startsWith('/team-management/lender-contacts')) setPageTitle('Contacts');
    if (pathname.startsWith('/team-management/exclusive-rates')) setPageTitle('Exclusive rates');
    if (pathname.startsWith('/team-management/lender-statuses')) setPageTitle('Statuses');
    if (pathname.startsWith('/team-management/notes-and-tags')) setPageTitle('Notes and tags');
    if (pathname === '/teams') setPageTitle('Team information');
    if (pathname.startsWith('/teams/documents')) setPageTitle('Team documents');
    if (pathname.startsWith('/teams/announcements')) setPageTitle('Team announcements');
    setMobileNavOpen(false);
  }, [brokerage?.name, pathname]);

  const toggleOpenMobileNav = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  return (
    <Navbar className="topbar" data-testid="layout-topbar">
      <div className="topbar-logo">
        <SpotlightLogoIcon className="w-6 text-white" />
      </div>
      <div className="topbar-content">
        {brokerage?.logo_path ? (
          <Navbar.Brand image={brokerage.logo_path} />
        ) : (
          <h1 className="topbar-logo-title">
            {brokerage ? <span>{brokerage.name}</span> : <span>Lender Spotlight</span>}
            {!features.is_pro && <span className="topbar-content__basic-label">Basic</span>}
          </h1>
        )}
        <h2 className="topbar-content__page-title" data-testid="topbar-content-page-title">
          {pageTitle}
        </h2>
        <div className="d-flex flex-row" id="topbar-portal" />
      </div>
      <MobileNav
        hasBrokerage={features.has_brokerage}
        canManageSubscriptions={features.can_manage_subscriptions}
        hasPaymentMethod={features.has_payment_method}
        isOpen={mobileNavOpen}
        onToggle={toggleOpenMobileNav}
      />
    </Navbar>
  );
};

export default Topbar;
